/** The maintained module catalog — the composed vocabulary a GameSpec may
 * name. Adding a module = author it under `modules/`, unit-test it in ≥2
 * configs, list it here. */
import type { AnyComposeModule } from './module.js';
import { platformerBody } from './modules/platformerBody.js';
import { surfaceBody, worldLayout, worldWrapX } from './modules/surfaces.js';
import { hopper, walker } from './modules/walker.js';
import { worldPipes } from './modules/pipes.js';
import { director } from './modules/director.js';
import { escalation, objective } from './modules/flow.js';
import { contactDamage, vitals } from './modules/vitals.js';
import { bumpFromBelow, kicker, powBlock, vulnerableWindow } from './modules/bump.js';
import { ballistic, debris, gun, pickup, staticBody, telegraph } from './modules/misc.js';
import { laneShip } from './modules/laneShip.js';
import { tether } from './modules/tether.js';
import { diver } from './modules/diver.js';
import { formation } from './modules/formation.js';
import { captor } from './modules/captor.js';
import { destructible } from './modules/destructible.js';
import { ladder } from './modules/ladder.js';
import { slide } from './modules/slide.js';
import { teleport } from './modules/teleport.js';
import { fallDamage } from './modules/fall.js';
import { claimTiles } from './modules/claim.js';
import { resource } from './modules/resource.js';
import { broadcast } from './modules/broadcast.js';
import { takeTurns } from './modules/takeTurns.js';
import { checkpoint } from './modules/checkpoint.js';
import { cursor, pressable } from './modules/pointer.js';
import { glide, patience, patron } from './modules/patron.js';
import { gauge, ticket } from './modules/order.js';
import { grade } from './modules/shift.js';
import { blast, bomb, fall, flight, reticle } from './modules/flight.js';
import { condition, scrollTrack, targets, turret } from './modules/strike.js';
import { heightfield } from './modules/terrain.js';
import { landingJudge, thrustRotate } from './modules/lander.js';
import { carve, course } from './modules/ski.js';
import { treads } from './modules/treads.js';
import { cannon, mount, ricochet } from './modules/cannon.js';
import { rounds } from './modules/rounds.js';

const MODULES: readonly AnyComposeModule[] = [
  // Movement (exactly one per archetype).
  platformerBody, walker, surfaceBody, staticBody, ballistic, laneShip, tether, diver, cursor, glide, flight, fall, reticle, thrustRotate, carve,
  treads, mount, ricochet,
  // Behaviour.
  hopper, gun, formation, captor, patron, ladder, slide, teleport, bomb, turret, cannon,
  // World.
  worldLayout, worldWrapX, worldPipes, scrollTrack, heightfield,
  // Rules.
  vitals, contactDamage, pickup, telegraph, bumpFromBelow, vulnerableWindow, kicker, powBlock, destructible,
  fallDamage, claimTiles, resource, broadcast, takeTurns, checkpoint,
  pressable, patience, ticket, gauge, blast, targets, landingJudge, course,
  // Flow.
  director, escalation, grade, rounds, objective,
  // Presentation.
  debris, condition,
];

export const COMPOSE_MODULES: ReadonlyMap<string, AnyComposeModule> = new Map(MODULES.map(m => [m.id, m]));
